"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pathEntriesMatch = exports.pathEntries = void 0;

var _is = require("./is");

const entries = (prefixPath, source) => {
  if ((0, _is.isArray)(source)) {
    return source.flatMap((item, index) => entries([...prefixPath, index], item));
  }

  if ((0, _is.isObject)(source)) {
    return Object.entries(source).reduce((acc, [key, value]) => {
      if ((0, _is.isObject)(value)) {
        return [...acc, ...entries([...prefixPath, key], value)];
      }

      if ((0, _is.isArray)(value)) {
        return [...acc, ...value.flatMap((item, index) => entries([...prefixPath, key, index], item))];
      }

      return [...acc, [[...prefixPath, key], value]];
    }, []);
  }

  return [[prefixPath, source]];
};

const pathEntries = source => {
  return entries([], source);
};

exports.pathEntries = pathEntries;

const entriesMatch = (prefixPath, source, isMatch) => {
  if ((0, _is.isArray)(source)) {
    return source.flatMap((item, index) => {
      if (isMatch(item)) {
        return [[[...prefixPath, index], item]];
      } else {
        return entriesMatch([...prefixPath, index], item, isMatch);
      }
    });
  }

  if ((0, _is.isObject)(source)) {
    return Object.entries(source).reduce((acc, [key, value]) => {
      if (isMatch(value)) {
        return [...acc, [[...prefixPath, key], value]];
      }

      if ((0, _is.isObject)(value)) {
        return [...acc, ...entriesMatch([...prefixPath, key], value, isMatch)];
      }

      if ((0, _is.isArray)(value)) {
        return [...acc, ...value.flatMap((item, index) => entriesMatch([...prefixPath, key, index], item, isMatch))];
      }

      return acc;
    }, []);
  }

  if (isMatch(source)) {
    return [[prefixPath, source]];
  } else {
    return [];
  }
};

const pathEntriesMatch = (source, isMatch) => {
  return entriesMatch([], source, isMatch);
};

exports.pathEntriesMatch = pathEntriesMatch;